import {
  getScaleResultsRequest,
  getScaleResultsResponse,
} from '@core-api/presentation/presentation/interactive-content/{interactive_content_id}/scale-results';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchScalesResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useFetchScalesResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseFetchScalesResultsParams) => {
  const requestParams = { interactiveContentId };

  const cacheKey = interactiveContentId
    ? getFetchResultsCacheKey('scales', adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getScaleResultsRequest,
    getResponse: getScaleResultsResponse,
  });
};
